// src/components/brandCustomization/EmailCustomization/EmailVariablesList.jsx
import React from 'react';
import { FaCode, FaInfoCircle } from 'react-icons/fa';
import { emailTemplateVariables } from '../../../utils/brandCustomization';

/**
 * EmailVariablesList - Lista de variables disponibles para un template
 */
const EmailVariablesList = ({ templateName }) => {
    const variables = emailTemplateVariables[templateName] || [];

    if (variables.length === 0) return null;

    return (
        <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
            <div className="flex items-center mb-3">
                <FaCode className="text-blue-600 mr-2" />
                <h4 className="text-sm font-semibold text-blue-900">Variables Disponibles</h4>
                <FaInfoCircle
                    className="text-blue-500 ml-2 cursor-help"
                    title="Usa estas variables en los textos para personalizar los emails"
                />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                {variables.map((variable, index) => (
                    <div key={index} className="flex items-start text-xs text-blue-800">
                        <span className="font-mono bg-white px-2 py-1 rounded mr-2 flex-shrink-0">
                            {variable.name}
                        </span>
                        <span className="text-gray-600">{variable.description}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default EmailVariablesList;

